var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.loading)?_c('day-skeleton'):_c('day',{attrs:{"day":_vm.day},on:{"roundClicked":_vm.selectRound}})
}
var staticRenderFns = []

export { render, staticRenderFns }